import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EquipmentsService } from 'app/main/equipments/services/equipments-resolver.service';
import { TabAttachmentsComponent } from './tab-attachments.component';

@NgModule({
  declarations: [
    TabAttachmentsComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    MatIconModule,
    MatRippleModule,
    MatTooltipModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule
  ],
  exports: [
    TabAttachmentsComponent
  ],
  providers: [
    EquipmentsService
  ]
})
export class TabAttachmentsModule { }
